// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/lifecircle-waves2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../images/step-direction.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preparation-lifecircle-modal .close-modal-btn {
  position: absolute;
  top: 5px;
  left: 5px;
  color: #ffffff;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  line-height: 25px;
  background: rgba(255, 255, 255, 0.3647058824);
  font-size: 14px;
  z-index: 1;
}
.preparation-lifecircle-modal .modal-content {
  position: relative;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 6px;
  background: #f9c52d;
}
.preparation-lifecircle-modal .modal-content::before {
  left: 0px;
  top: 145px;
  content: "";
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  width: 120px;
  height: 60px;
}
.preparation-lifecircle-modal .modal-content .lines-img {
  position: absolute;
  top: 0px;
  right: 5px;
}
.preparation-lifecircle-modal .modal-content .plm-content {
  position: relative;
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-] {
  position: relative;
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:not(:last-child)::before {
  width: 74px;
  height: 100%;
  right: -38px;
  top: -5px;
  content: "";
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 100px;
  background-position: center;
  z-index: 1;
}
@media (max-width: 575.98px) {
  .preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(1)::before {
    top: -12px;
  }
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(1) .direction-btn {
  border-radius: 32% 70% 52% 50%/44% 50% 56% 70%;
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(2)::before {
  width: 80px;
  right: -40px;
  top: 14px;
  transform: rotate(-180deg) scaleX(-1);
}
@media (max-width: 575.98px) {
  .preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(2)::before {
    width: 70px;
    right: -34px;
    top: 16px;
  }
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(2) .direction-btn {
  border-radius: 38% 36% 27% 64%/60% 52% 50% 45%;
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(3)::before {
  width: 80px;
  right: -38px;
  top: -12px;
}
@media (max-width: 575.98px) {
  .preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(3)::before {
    width: 74px;
    right: -35px;
    top: -11px;
  }
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(3) .direction-btn {
  border-radius: 32% 70% 52% 50%/44% 50% 56% 70%;
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-]:nth-child(4) .direction-btn {
  border-radius: 56% 36% 34% 39%/52% 58% 42% 45%;
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-] .direction-btn {
  padding: 10px;
  width: 70px;
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: #00040a;
  text-decoration: none;
  border: 1px solid #f9c52d;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1215686275);
  font-size: 11px;
  z-index: 1;
}
@media screen and (min-width: 992px) {
  .preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-] .direction-btn {
    font-size: 14px;
    width: 100px;
  }
}
.preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-] .direction-btn:hover, .preparation-lifecircle-modal .modal-content .plm-content .plm-nav [class*=col-] .direction-btn.active {
  border: 1px solid #fff;
  background: #f9c52d;
}
.preparation-lifecircle-modal .modal-content .plm-content .single-modal-card {
  border-radius: 0.5rem;
  overflow: hidden;
}
.preparation-lifecircle-modal .modal-content .plm-content .single-modal-card .card-body .lifecircle-modal-title {
  font-size: 15px;
}
.preparation-lifecircle-modal .modal-content .plm-content .single-modal-card .card-body .lifecircle-modal-text {
  font-size: 14px;
}
.preparation-lifecircle-modal .modal-content .plm-content .single-modal-card .card-footer {
  text-align: center;
  background: linear-gradient(106deg, #ecc602 0%, #e7889e 100%);
}
.preparation-lifecircle-modal .modal-content .plm-content .single-modal-card .card-footer i {
  right: 5px;
  position: absolute;
  background: #fff;
  color: #000;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  line-height: 25px;
}

.mobile-start-modal .close-modal-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
  box-shadow: none;
  outline: none;
}
.mobile-start-modal .modal-content {
  position: relative;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 2.5rem;
  overflow: hidden;
}
.mobile-start-modal .modal-content .modal-body .custom-card {
  margin-top: 2rem;
  margin-bottom: 12rem;
  margin: 0 auto;
  position: relative;
  background: transparent;
  z-index: 1;
}
.mobile-start-modal .modal-content .modal-body .content .title {
  color: #111b51;
  font-weight: 700;
}
.mobile-start-modal .modal-content .modal-body .content .subtitle {
  color: #000;
  font-weight: 400 !important;
}
.mobile-start-modal .modal-content .modal-body .content .description {
  font-size: 1.2rem;
  color: #000;
  text-transform: uppercase;
}
.mobile-start-modal .modal-content .modal-body .waves img {
  position: absolute;
}
.mobile-start-modal .modal-content .modal-body .waves img.img-1 {
  left: -65px;
  top: -90px;
  transform: rotate(-5deg);
}
.mobile-start-modal .modal-content .modal-body .waves img.img-2 {
  top: -120px;
  right: -100px;
}
.mobile-start-modal .modal-content .modal-body .waves img.img-3 {
  right: -62px;
  bottom: -70px;
}
.mobile-start-modal .modal-content .modal-body .waves img.img-4 {
  left: -143px;
  bottom: -143px;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/home/starting_modal/_starting-modal.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6CAAA;EACA,eAAA;EACA,UAAA;AAAJ;AAGE;EACE,kBAAA;EACA,oDAAA;EACA,kBAAA;EACA,mBAAA;AADJ;AAGI;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;AADN;AAII;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAFN;AAKI;EACE,kBAAA;AAHN;AAMQ;EACE,kBAAA;AAJV;AAMU;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;AAJZ;AAQY;EACE;IACE,UAAA;EANd;AACF;AASY;EACE,8CAAA;AAPd;AAYY;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,qCAAA;AAVd;AAYc;EANF;IAOI,WAAA;IACA,YAAA;IACA,SAAA;EATd;AACF;AAYY;EACE,8CAAA;AAVd;AAeY;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAbd;AAec;EALF;IAMI,WAAA;IACA,YAAA;IACA,UAAA;EAZd;AACF;AAeY;EACE,8CAAA;AAbd;AAkBY;EACE,8CAAA;AAhBd;AAoBU;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oDAAA;EACA,eAAA;EACA,UAAA;AAlBZ;AAoBY;EAdF;IAeI,eAAA;IACA,YAAA;EAjBZ;AACF;AAmBY;EAEE,sBAAA;EACA,mBAAA;AAlBd;AAwBM;EACE,qBAAA;EACA,gBAAA;AAtBR;AAyBU;EACE,eAAA;AAvBZ;AA0BU;EACE,eAAA;AAxBZ;AA4BQ;EACE,kBAAA;EACA,6DAAA;AA1BV;AA4BU;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA1BZ;;AAmCE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;AAhCJ;AAkCE;EACE,kBAAA;EACA,oDAAA;EACA,qBAAA;EACA,gBAAA;AAhCJ;AAkCM;EACE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EAEA,UAAA;AAjCR;AAoCQ;EACE,cAAA;EACA,gBAAA;AAlCV;AAoCQ;EACE,WAAA;EACA,2BAAA;AAlCV;AAoCQ;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;AAlCV;AAqCM;EACE,kBAAA;AAnCR;AAqCQ;EACE,WAAA;EACA,UAAA;EACA,wBAAA;AAnCV;AAqCQ;EACE,WAAA;EACA,aAAA;AAnCV;AAqCQ;EACE,YAAA;EACA,aAAA;AAnCV;AAqCQ;EACE,YAAA;EACA,cAAA;AAnCV","sourcesContent":[".preparation-lifecircle-modal {\n  .close-modal-btn {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    color: #ffffff;\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    line-height: 25px;\n    background: #ffffff5d;\n    font-size: 14px;\n    z-index: 1;\n  }\n\n  .modal-content {\n    position: relative;\n    box-shadow: 0px 3px 20px #00000029;\n    border-radius: 6px;\n    background: #f9c52d;\n\n    &::before {\n      left: 0px;\n      top: 145px;\n      content: \"\";\n      position: absolute;\n      background: url(\"../../../../images/lifecircle-waves2.png\");\n      background-repeat: no-repeat;\n      width: 120px;\n      height: 60px;\n    }\n\n    .lines-img {\n      position: absolute;\n      top: 0px;\n      right: 5px;\n    }\n\n    .plm-content {\n      position: relative;\n\n      .plm-nav {\n        [class*=\"col-\"] {\n          position: relative;\n\n          &:not(:last-child)::before {\n            width: 74px;\n            height: 100%;\n            right: -38px;\n            top: -5px;\n            content: \"\";\n            position: absolute;\n            background: url(\"../../../../images/step-direction.png\");\n            background-repeat: no-repeat;\n            background-size: 100px;\n            background-position: center;\n            z-index: 1;\n          }\n\n          &:nth-child(1) {\n            @media (max-width: 575.98px) {\n              &::before {\n                top: -12px;\n              }\n            }\n\n            .direction-btn {\n              border-radius: 32% 70% 52% 50% / 44% 50% 56% 70%;\n            }\n          }\n\n          &:nth-child(2) {\n            &::before {\n              width: 80px;\n              right: -40px;\n              top: 14px;\n              transform: rotate(-180deg) scaleX(-1);\n\n              @media (max-width: 575.98px) {\n                width: 70px;\n                right: -34px;\n                top: 16px;\n              }\n            }\n\n            .direction-btn {\n              border-radius: 38% 36% 27% 64% / 60% 52% 50% 45%;\n            }\n          }\n\n          &:nth-child(3) {\n            &::before {\n              width: 80px;\n              right: -38px;\n              top: -12px;\n\n              @media (max-width: 575.98px) {\n                width: 74px;\n                right: -35px;\n                top: -11px;\n              }\n            }\n\n            .direction-btn {\n              border-radius: 32% 70% 52% 50% / 44% 50% 56% 70%;\n            }\n          }\n\n          &:nth-child(4) {\n            .direction-btn {\n              border-radius: 56% 36% 34% 39% / 52% 58% 42% 45%;\n            }\n          }\n\n          .direction-btn {\n            padding: 10px;\n            width: 70px;\n            position: relative;\n            display: inline-block;\n            cursor: pointer;\n            color: #00040a;\n            text-decoration: none;\n            border: 1px solid #f9c52d;\n            background: #ffffff;\n            box-shadow: 0px 3px 10px #0000001f;\n            font-size: 11px;\n            z-index: 1;\n\n            @media screen and (min-width: 992px) {\n              font-size: 14px;\n              width: 100px;\n            }\n\n            &:hover,\n            &.active {\n              border: 1px solid #fff;\n              background: #f9c52d;\n            }\n          }\n        }\n      }\n\n      .single-modal-card {\n        border-radius: 0.5rem;\n        overflow: hidden;\n\n        .card-body {\n          .lifecircle-modal-title {\n            font-size: 15px;\n          }\n\n          .lifecircle-modal-text {\n            font-size: 14px;\n          }\n        }\n\n        .card-footer {\n          text-align: center;\n          background: linear-gradient(106deg, #ecc602 0%, #e7889e 100%);\n\n          i {\n            right: 5px;\n            position: absolute;\n            background: #fff;\n            color: #000;\n            border-radius: 50%;\n            width: 25px;\n            height: 25px;\n            line-height: 25px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.mobile-start-modal {\n  .close-modal-btn {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    z-index: 1;\n    box-shadow: none;\n    outline: none;\n  }\n  .modal-content {\n    position: relative;\n    box-shadow: 0px 3px 20px #00000029;\n    border-radius: 2.5rem;\n    overflow: hidden;\n    .modal-body {\n      .custom-card {\n        margin-top: 2rem;\n        margin-bottom: 12rem;\n        margin: 0 auto;\n        position: relative;\n        background: transparent;\n        // box-shadow: 12px 1px 12px 2px rgba(0, 0, 0, 0.175);\n        z-index: 1;\n      }\n      .content {\n        .title {\n          color: #111b51;\n          font-weight: 700;\n        }\n        .subtitle {\n          color: #000;\n          font-weight: 400 !important;\n        }\n        .description {\n          font-size: 1.2rem;\n          color: #000;\n          text-transform: uppercase;\n        }\n      }\n      .waves img {\n        position: absolute;\n\n        &.img-1 {\n          left: -65px;\n          top: -90px;\n          transform: rotate(-5deg);\n        }\n        &.img-2 {\n          top: -120px;\n          right: -100px;\n        }\n        &.img-3 {\n          right: -62px;\n          bottom: -70px;\n        }\n        &.img-4 {\n          left: -143px;\n          bottom: -143px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
